var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVimeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.17346 8.30112C0.891555 7.88758 0.921467 7.88758 1.50086 7.37867C2.7329 6.29651 3.89542 5.11316 5.23728 4.1668C6.45248 3.31485 8.06319 2.7652 9.16368 4.1202C10.1781 5.36886 10.202 7.26157 10.4589 8.76952C10.7158 10.3336 10.962 11.9336 11.5104 13.4308C11.6622 13.8514 11.9525 14.6472 12.4783 14.7141C13.1558 14.8073 13.8464 13.6184 14.1607 13.1739C14.978 11.9945 16.0857 10.4053 15.9459 8.88781C15.8084 7.27591 14.0675 7.57941 12.9801 7.96416C13.1546 6.1551 14.8382 4.1214 16.4597 3.43314C18.1791 2.71979 20.7362 2.73174 21.6001 4.67105C22.5225 6.77286 21.6933 9.21402 20.6884 11.1187C19.5915 13.187 18.1791 15.1012 16.67 16.8888C15.3389 18.4768 13.764 20.2189 11.7793 20.9777C9.51259 21.8416 8.16954 20.158 7.39764 18.2079C6.55524 16.0846 6.13584 13.702 5.52764 11.4915C5.27193 10.5571 4.96843 9.49362 4.36142 8.72292C3.56921 7.72757 2.66946 8.66317 1.88681 9.19968C1.61796 8.93322 1.39571 8.59267 1.17346 8.30112Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeo);
export default __webpack_public_path__ + "static/media/vimeo.4e0ca328a917b1c949072c840ed4eb8a.svg";
export { ForwardRef as ReactComponent };